import { RootState } from "../../store";

export const authTokenSelector = (rootState: RootState) =>
  rootState.user.authToken;
export const userDataSelector = (rootState: RootState) =>
  rootState.user.userData;
